import React from 'react';
import { styles } from './LegacyContactBlock.css';
import CrazyFont from '@jbhi-fi/lanyard-ui/font/CrazyFont';
import { Icon, IconName } from '@jbhi-fi/lanyard-ui/components/Icon';
import { IconProps } from '@jbhi-fi/lanyard-ui/components/Icon/CustomIcon';
import { TrackingProvider, useTrackingContext } from '../../Tracking';
import { useNavigate } from '../../PlatformFunctionality';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { useIdPrefix } from '../../IdPrefix';

export type LegacyContactBlockProps = {
  heading?: string;
  subText?: string;
  idComponent?: string;
  chatText: string;
  chatUrl?: string;
  chatOnClick?: () => void;
  shouldHideCallUs?: boolean;
  callText?: string;
  callUrl?: string;
  callOnClick?: () => void;
};

type ContactButtonProps = {
  icon: IconName;
  text: string;
  link?: string;
  onClickHandler?: () => void;
  iconProps?: IconProps;
  testId?: string;
};

const ContactButton = ({ icon, iconProps, text, link, onClickHandler, testId }: ContactButtonProps) => {
  const { tracker } = useTrackingContext();
  const navigate = useNavigate();

  const handleOnClick = () => {
    tracker.trackClick({ label: text, extraData: { moduleName: 'Contact block' } });
    if (link) {
      navigate(link);
    } else if (onClickHandler) {
      onClickHandler();
    }
  };

  return (
    <Button
      type="linkWithIcon"
      className={styles.actionButton}
      iconPosition="left"
      onClick={handleOnClick}
      icon={
        <span className={styles.icon}>
          <Icon {...iconProps} name={icon} />
        </span>
      }
      data-testid={testId}
    >
      {text}
    </Button>
  );
};

export const LegacyContactBlock = ({
  heading,
  subText,
  chatText,
  chatUrl,
  chatOnClick,
  shouldHideCallUs,
  callText,
  callUrl,
  callOnClick,
  idComponent,
}: LegacyContactBlockProps) => {
  const suffixId = idComponent ? `${idComponent}-` : '';
  const chatId = useIdPrefix(`${suffixId}chat`);
  const callId = useIdPrefix(`${suffixId}call`);

  return (
    <TrackingProvider shouldInheritFromParentContexts group={heading}>
      <div className={styles.container} id={useIdPrefix(`${suffixId}contact-block`)}>
        {subText ? <h4 className={styles.subText}>{subText}</h4> : null}
        {heading ? (
          <CrazyFont variant="withShadowAndOutline" as="h3" className={styles.heading}>
            {heading}
          </CrazyFont>
        ) : null}
        <div className={styles.actionWrapper}>
          <ContactButton icon="Chat" text={chatText} link={chatUrl} onClickHandler={chatOnClick} testId={chatId} />
          {!shouldHideCallUs && callText ? (
            <ContactButton
              icon="Phone"
              iconProps={{ style: { marginRight: '-0.3em' } }}
              text={callText}
              link={callUrl}
              onClickHandler={callOnClick}
              testId={callId}
            />
          ) : null}
        </div>
      </div>
    </TrackingProvider>
  );
};
